module.exports = __webpack_public_path__ + "img/pop_06.c07a0bf2.png";